const DECLINE_SOURCE_LABEL_KEYS = Object.freeze({
	invitation_declined: 'application.decline-source.invitation-declined',
	withdrawn: 'application.decline-source.withdrawn'
})

export function getDeclineSourceLabelKey(source) {
	return DECLINE_SOURCE_LABEL_KEYS[source] || null
}

export function isApplicationArchiveLocked(application) {
	if (application?.status !== 'denied') return false

	return application.decline_source !== 'company'
}

export function getApplicationArchiveLockReasonKey(application) {
	if (!isApplicationArchiveLocked(application)) return null

	if (application.decline_source === 'withdrawn') {
		return 'application.move-stage.withdrawn-locked'
	}

	if (application.decline_source === 'invitation_declined') {
		return 'application.move-stage.invitation-declined-locked'
	}

	return 'application.move-stage.archive-locked'
}
